const DimInventoryTypeList = [
    {
        id: null,
        text: "全部"
    },
    {
        id: "1",
        text: "库存商品"
    },
    {
        id: "2",
        text: "原材料"
    },
    {
        id: "3",
        text: "周转材料"
    }
];

export default DimInventoryTypeList;